import fetch from 'unfetch';
import useSWRInfinite from 'swr/infinite';

const fetcher = (...args) => fetch(...args).then((res) => res.json());

const PAGE_SIZE = 5;

export default function usePages({ language = 'fi', searchQuery = '' }) {
  const {
    data, error, size, setSize, isValidating,
  } = useSWRInfinite((index, previousData) => {
    // Last page.
    if (previousData && previousData.pages === index) { return null; }

    return `/wp-json/odl/v1/search-engine/?post_type=odl_contact&lang=${language}&search_query=${searchQuery}&per_page=${PAGE_SIZE}&page=${index + 1}`;
  }, fetcher);

  const isLoadingInitialData = !data && !error;

  return {
    page: data,
    size,
    setSize,
    isValidating,
    isLoadingInitialData,
    isError: error,
  };
}
